import React from 'react'
import { Col, Container, Row, Image } from 'react-bootstrap'
import shopifyLogo from '../../../Assets/images/shopify-img/shopify-logo-black-img.png'
import { useHistory } from 'react-router-dom'

const DevelopmentExpertise = () => {
    const history = useHistory();
    const  DevelopmentExpertise = [
        { title: "Custom Shopify Theme Development" },
        { title: "App Integration & Optimization" },
        { title: "Store Performance Optimization" },
        { title: "SEO Implementation" },
        { title: "Mobile-First Design" },
        { title: "Conversion Rate Optimization (CRO)" },
        { title: "E-commerce Analytics & Insights" },
        { title: "Secure Payment Gateway Integration" },
        { title: "Product Integration" },
        { title: "Ongoing Support & Maintenance" }
      ];
  return (
    <div className='development_expertise_section'>
        <Container className='bw_custome_footer_container'>
            <Row>
                <Col sm={12} md={5} lg={5}>
                <div className='development_expertise_section_left'>
                <h2 className='sho_heading'>Our  
                <Image src={shopifyLogo} alt="shopify Logo image" className='img-fluid' style={{cursor: 'pointer'}}/> <br/>
                Development Expertise</h2>
                <p>At Belgium WebNet, we bring deep technical knowledge and creative
strategy to every Shopify project. Here's what we specialize in:
At Belgium WebNet, we blend sharp technical skills with fresh creative
strategy to build Shopify stores that truly stand out. Here’s what we do best:</p>
<button className='shopify_btn_outline_black' onClick={() => history.push('/consultation')}>Book A Free Consultation</button>
                </div>
                
                </Col>
                <Col sm={12} md={7} lg={7}>
                <div className='development_expertise_section_right'>
<ul>
   {
    DevelopmentExpertise.map((item, index) => (
        <li key={index}>
            <div className='development_expertise_section_right_box_list'>
                <p>{item.title}</p>
            </div>
        </li>
    ))
   } 
</ul>
                </div>
                </Col>
            </Row>
        </Container>
    </div>
  )
}

export default DevelopmentExpertise